import { useCallback, useState } from 'react';

type ToggleFn = (newValue?: boolean) => void;

interface UseToggleFn {
  (initialState?: boolean): [boolean, ToggleFn]
}

const useToggle: UseToggleFn = (initialState = false) => {
  const [value, setValue] = useState<boolean>(initialState);

  const toggleValue = useCallback((newValue?: boolean) => {
    setValue(oldValue => newValue !== undefined ? newValue : !oldValue);
  }, []);

  return [value, toggleValue];
};

export default useToggle;
